import { useContext, useEffect, useState } from "react";
import { getSortedCollection } from "sprint-common-web";

import { SystemPlatformDetailsContext } from "../../context/SystemPlatformDetailsContext";
import { SystemPlatformDetailsSpecificationItem } from "../../SystemPlatformDetailsItem";

export const useSpecificationListing = () => {
    const [items, setItems] = useState<SystemPlatformDetailsSpecificationItem[]>([]);

    const { systemPlatformDetailsItem, isLoading } = useContext(SystemPlatformDetailsContext);
    const { specifications } = systemPlatformDetailsItem;

    useEffect(() => {
        const sortedItems = getSortedCollection(specifications, "name");
        setItems(sortedItems);
    }, [specifications]);

    return {
        items,
        isLoading
    };
};
